import { reactive } from 'vue'

// ! global notifications

const state = reactive({
    count: 0,
    notification_general: [],
    notification_warnings: [],
    notification_errors: [],
    notification_success: [],
    notification_role: [],
    notification_me: []
})

const keys = [
    "general",
    "warnings",
    "errors",
    "success",
    "role",
    "me"
]

const methods = {

    setCount: function () {
        state.count = (state.notification_general.filter(data => data.read === false).length)
            + (state.notification_warnings.filter(data => data.read === false).length)
            + (state.notification_errors.filter(data => data.read === false).length)
            + (state.notification_success.filter(data => data.read === false).length)
            + (state.notification_role.filter(data => data.read === false).length)
            + (state.notification_me.filter(data => data.read === false).length);
    },

    setNotification: function (notifications, key) {
       
        if (state[`notification_${key}`].length) return ({ success: false, code: 400, error: "Update notification" });
        if (!keys.includes(key)) ({ success: false, code: 401, error: "Missing notification key" }); 
        state[`notification_${key}`] = [...state[`notification_${key}`], notifications];
        this.setCount();
        return ({ success: true, code: 201, message: "notifications added" });
    }

}


export default {
    state,
    methods
}